module.exports = __webpack_public_path__ + "img/home_img_01.53af43d9.png";